import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import MarketingControlledButton from '../../../components/marketing-controlled-buttons';
import { usePremiumAccess } from '../../../providers';
import { NavigationDivider } from '../styles';
import { PremiumStatusBlockContainer } from './styles';
const PremiumStatusBlock = ({ company, admin, openMeetingModalClicked, }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { accessLevel } = usePremiumAccess();
    return (_jsxs(_Fragment, { children: [_jsx(NavigationDivider, { style: { marginBlock: theme.appearance.spacing * 2 } }), _jsxs(PremiumStatusBlockContainer, { children: [_jsx(Typography, { elementTheme: "body3", textAlign: "center" }), _jsx(Typography, { elementTheme: "body3", textAlign: "center", children: parse(t(accessLevel === 'free'
                            ? 'premium_feature|premium_upgrade_nav_title'
                            : accessLevel === 'premium' || accessLevel === 'expert'
                                ? 'premium_feature|premium_talk_to_manager_nav_title'
                                : 'premium_feature|custom_talk_to_manager_nav_title')) }), _jsx(MarketingControlledButton, { type: "navigation", company: company, admin: admin, openMeetingModalClicked: openMeetingModalClicked })] })] }));
};
export default PremiumStatusBlock;
